import {CalendarSquareRegularEventIcon} from 'shells/icon/svg/calendar-square-regular-event-icon';
import {CloseHeavyRegularIcon} from 'shells/icon/svg/close-heavy-regular-icon';
import {CogRegularIcon} from 'shells/icon/svg/cog-regular-icon';

import {type RecurrenceRuleInput, RecurrenceMode} from 'nutshell-graphql-types';

import {SelectMenu} from '../../select-menu/select-menu';

import {getDefaultOptions} from './helpers';

interface Props {
    // If not passed, the current date will be used
    referenceDatetime?: number | null | undefined;
    anchor: HTMLElement | null;
    onRecurrenceRuleSelected: (recurrenceRule: RecurrenceRuleInput | null) => void;
    onCustomSelected: () => void;
    onClose: () => void;
}
export function RecurrenceSelect(props: Props) {
    const {weekly, monthly, threeMonthly} = getDefaultOptions(props.referenceDatetime);

    const options = [
        {
            label: 'Does not repeat',
            key: 'none',
            icon: <CloseHeavyRegularIcon size={16} alignCenter={true} />,
            handleSelect: () => {
                props.onRecurrenceRuleSelected(null);
            },
        },
        {
            label: weekly.label,
            key: `RRULE:${weekly.rule}`,
            icon: <CalendarSquareRegularEventIcon size={16} alignCenter={true} />,
            handleSelect: () => {
                props.onRecurrenceRuleSelected({
                    mode: RecurrenceMode.DUE_DATE,
                    rule: weekly.rule,
                });
            },
        },
        ...monthly.map((option) => ({
            label: option.label,
            key: `RRULE:${option.rule}`,
            icon: <CalendarSquareRegularEventIcon size={16} alignCenter={true} />,
            handleSelect: () => {
                props.onRecurrenceRuleSelected({
                    mode: RecurrenceMode.DUE_DATE,
                    rule: option.rule,
                });
            },
        })),
        {
            label: threeMonthly.label,
            key: `RRULE:${threeMonthly.rule}`,
            icon: <CalendarSquareRegularEventIcon size={16} alignCenter={true} />,
            handleSelect: () => {
                props.onRecurrenceRuleSelected({
                    mode: RecurrenceMode.DUE_DATE,
                    rule: threeMonthly.rule,
                });
            },
        },
        {
            label: 'Custom',
            key: 'custom',
            icon: <CogRegularIcon size={16} alignCenter={true} />,
            handleSelect: () => {
                props.onCustomSelected();
            },
        },
    ];

    return (
        <>
            <SelectMenu
                anchor={props.anchor}
                options={options}
                onClose={props.onClose}
                location='bottom-right'
            />
        </>
    );
}
